import React, { memo } from 'react';
import styled from 'styled-components';
import {
  COLORS,
  FONTS,
  FONT_SIZE,
  NO_SELECT,
  PADDING,
} from '@constants/styles';

const ST = {
  Wrapper: styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    ${NO_SELECT}
  `,
  Container: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    // flex: 1;
    overflow: hidden;
  `,
  Title: styled.span`
    text-align: center;
    font-size: ${FONT_SIZE.PX16};
    font-family: ${FONTS.BOLD};
    color: ${COLORS.BLACK};
  `,
  Subtitle: styled.span`
    text-align: center;
    font-size: ${FONT_SIZE.PX16};
    font-family: ${FONTS.NORMAL};
    padding-left: ${PADDING.MD};
    color: ${COLORS.MAIN};
  `,
};

interface Props {
  title: string;
  subtitle: string;
}

const GraphTitle: React.FC<Props> = ({ title, subtitle }) => (
  <ST.Wrapper>
    <ST.Container>
      <ST.Title>{title}</ST.Title>
      <ST.Subtitle>{subtitle}</ST.Subtitle>
    </ST.Container>
  </ST.Wrapper>
);

export default memo(GraphTitle);
